module.exports = __webpack_public_path__ + "static/media/logo-prod.cee8618c.svg";